export default __webpack_public_path__ + "static/media/chlorinld.8afe11e9.png";